// extracted by mini-css-extract-plugin
export default {"main":"CompliantRegulations_main__hRef4","loadingState":"CompliantRegulations_loadingState__7DYnY","list":"CompliantRegulations_list__v-+zf"};